/**
 * hook: useAPI()
 *
 * Hooks to communicate with the backend.
 */

import useMrcAuth from './useMrcAuth';

import getLang from 'Utils/getLang';

const internal = {
  fetch: (path, params) => {
    const { appConfig } = window;
    const { blogUrl, restApi } = appConfig;
    const lang = getLang();

    const url = `${blogUrl}${restApi}/${lang}${path}`;
    return window.fetch(url, params)
      .then(response => {
        if (!response.ok) {
          // eslint-disable-next-line no-console
          console.log(response);
          throw new Error('Failed to fetch API response, details above');
        }

        return response.json();
      })
      // eslint-disable-next-line no-console
      .catch(ex => console.error(ex));
  },
};

export default () => {
  const auth = useMrcAuth();

  internal.fetchWithToken = (path, params) => internal.fetch(path, {
    ...(params || {}),
    headers: {
      ...(params || {}).headers,
      'X-ARTE-Authorization': `Bearer ${auth.token}`,
    },
  });

  internal.fetchProgram = (date, programId) => internal.fetch(`/program/${date}/${programId}`);
  internal.fetchWebonly = (teaserId) => internal.fetch(`/webonly/${teaserId}`);
  internal.fetchSiblingHighlights = highlightId => internal.fetch(`/terms/siblings/${highlightId}`);
  internal.fetchWebOnlyAgenda = () => internal.fetch(`/webonly/agenda?group=month`);
  internal.fetchFooterItems = () => internal.fetch(`/footerItems`);

  // needs auth
  internal.fetchExternalVideoPassword = highlightId => internal.fetchWithToken(`/highlight/externalVideoPassword/${highlightId}`);

  return internal;
};
